import { createSelector } from '@reduxjs/toolkit';
import { selectDatesValue } from './selectDatesValue';
import { formatDate } from './utils';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { EPageType } from 'shared/types/page';

export const selectDatesLabel = createSelector(
  selectDatesValue,
  selectPageType,
  selectIsInlineFiltersRedesigned,
  (dates, pageType, isRedesigned) => {
    const { from, to } = dates;

    if (!from || !to) {
      if (pageType === EPageType.MAIN && isRedesigned) {
        return 'Даты';
      } else {
        return 'Выберите даты';
      }
    }

    const today = new Date();
    const isSameYear = from.getFullYear() === to.getFullYear();
    const isCurrentYear = from.getFullYear() === today.getFullYear();
    const shouldPrintYear = !isSameYear || !isCurrentYear;

    return `${formatDate(from, shouldPrintYear)} — ${formatDate(to, shouldPrintYear)}`;
  },
);
